module.exports = __webpack_public_path__ + "static/media/event.11b42643.png";